module.exports = "https://static.zego.com/_next/static/images/TrustpilotColor-3e2b315705cb03dece2df3f29f0127eb.png";